import { render, staticRenderFns } from "./sendHistory.vue?vue&type=template&id=09e763e0&scoped=true&"
import script from "./sendHistory.vue?vue&type=script&lang=js&"
export * from "./sendHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e763e0",
  null
  
)

export default component.exports